<script>
import { Validator } from 'simple-vue3-validator'
import axios from 'axios';
import useAppRouter from '../../composables/useAppRouter';

export default {
  data() {
    return {
      minPasswordLength: 9,
      serverMessage: '',
      linkAccountMode: false,     
      accountAccessToken: null,
      signupModel: {
        Email: '',
        ConfirmEmail: '',
        Password: '',
        FirstName: '',
        LastName: '',
        DateOfBirth: '',
        ReturnUrl: ''
      },
      router: useAppRouter,
    }
  },
  watch: {
    signupModel: {
      handler() {
        this.signupModel.ConfirmEmail = this.signupModel.Email;
        this.serverMessage = "";
      },
      deep: true
    }
  },
  methods: {
    async executeRegister() {
      return axios.post('/account/register', this.signupModel, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
    },
    async submitRegistration() {
      var vm = this;
      var success = await this.$validate()

      if (success) {
        if (vm.linkAccountMode && vm.accountAccessToken && vm.accountAccessToken.length > 0) {
          vm.signupModel.Provider = "facebook";
          vm.signupModel.Data = vm.accountAccessToken;
        }

        try {
          var res = await vm.executeRegister();          
          vm.$gfLogger.logInfo("Registration response:", res);          
          if (res.status === 200 && res.data && !res.data.success) {
            vm.serverMessage = res.data.message;
            if (res.data.showProviderButton && res.data.showProviderButton === true) {
              vm.showFacebookButton = true;
            }
            return;
          }

          if (res.status === 200 && res.data.TempData === undefined) {            
            vm.$emit('loggedIn', res.data.userEmail);
            return vm.redirectToPage(vm.returnUrl);
          }
          return vm.processServerResponse(res.data)
        }
        catch (err) {
          console.log("Error during registration: " + err);
        }
      }
    },
    processServerResponse: function (data) {
      if (data.TempData["Status.Css"] && data.TempData["Status.Css"].toLowerCase() == "error")
        this.serverMessage = data.TempData["Status.Message"];
    },

    redirectToPage: function (url) {
      if (this.disableRedirect)
        return

      window.location.replace(url);
    }
  },
  validators: {
    'signupModel.Email': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required().email();
    },
    'signupModel.Password': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required().minLength(this.minPasswordLength);
    },
    'signupModel.FirstName': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required();
    },
    'signupModel.LastName': function (value) {
      if (!this.linkAccountMode)
        return Validator.value(value).required();
    }
  }
}
</script>
